import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';
import { Plus, FolderOpen, X, Trash2 } from 'lucide-react';

const Categories = () => {
  const { t } = useTranslation();
  const { currentBusiness } = useAuth();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');

  useEffect(() => {
    fetchCategories();
    const handleBusinessChange = () => fetchCategories();
    window.addEventListener('businessChanged', handleBusinessChange);
    return () => window.removeEventListener('businessChanged', handleBusinessChange);
  }, [currentBusiness]);

  const fetchCategories = async () => {
    try { const res = await api.get('/categories'); setCategories(res.data); } catch (err) {}
    setLoading(false);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try { await api.post('/categories', { name }); setName(''); setShowModal(false); fetchCategories(); }
    catch (err) { alert('Failed'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete?')) return;
    try { await api.delete(`/categories/${id}`); fetchCategories(); } catch (err) {}
  };

  if (loading) return <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin"></div></div>;

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div><h2 className="text-xl md:text-2xl font-bold text-white">Categories</h2><p className="text-gray-400 text-sm mt-1">Organize your products</p></div>
        <button onClick={() => setShowModal(true)} className="flex items-center gap-2 bg-emerald-500 text-white px-4 py-2.5 rounded-xl font-medium hover:bg-emerald-600 transition text-sm"><Plus size={18} /> Add Category</button>
      </div>
      {categories.length === 0 ? (
        <div className="bg-[#0d1410] border border-white/5 rounded-2xl p-12 text-center"><FolderOpen size={48} className="text-gray-600 mx-auto mb-4" /><p className="text-gray-400 font-medium">No categories yet</p></div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {categories.map((cat) => (
            <div key={cat.id} className="bg-[#0d1410] border border-white/5 rounded-xl p-4 flex items-center justify-between">
              <div className="flex items-center gap-3"><div className="p-2.5 bg-emerald-500/10 rounded-xl"><FolderOpen size={20} className="text-emerald-400" /></div><span className="text-white font-medium text-sm">{cat.name}</span></div>
              <button onClick={() => handleDelete(cat.id)} className="text-gray-600 hover:text-red-400 transition"><Trash2 size={16} /></button>
            </div>
          ))}
        </div>
      )}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-[#111a14] border border-white/10 rounded-2xl p-6 w-full max-w-md">
            <div className="flex items-center justify-between mb-6"><h3 className="text-white font-bold text-lg">Add Category</h3><button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-white"><X size={20} /></button></div>
            <form onSubmit={handleAdd} className="space-y-4">
              <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Category name" className="w-full px-4 py-3 bg-[#0d1611] border border-white/10 rounded-xl text-white text-sm" required />
              <div className="flex gap-3"><button type="button" onClick={() => setShowModal(false)} className="flex-1 py-3 border border-white/10 rounded-xl text-gray-400 text-sm">Cancel</button><button type="submit" className="flex-1 py-3 bg-emerald-500 text-white rounded-xl font-medium text-sm">Save</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Categories;
